import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { fab, faCss3, faHtml5, faJsSquare, faReact, faNodeJs, faPhp, faJava, faAndroid, faUikit, faAdobe, faPython, faHackerrank, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import js from '../assets/images/js.svg';
import php from '../assets/images/php.svg';
import python from '../assets/images/python.svg';
import react from '../assets/images/react.png';
import nodejs from '../assets/images/nodejs.svg';
import java from '../assets/images/java.png';
import android from '../assets/images/android.png';
import adobexd from '../assets/images/adobexd.png';
import photoshop from '../assets/images/photoshop.png';
import linux from '../assets/images/linux.png';
import {Link} from 'react-router-dom';
import Nav from './Header/Nav';
import Subscribe from './components/Subscribe';
import App from  '../assets/style/sass/App.scss';
import SideBar from './sidebar/SideBar';
import Footer from './components/Footer';
import DevelopRequest from './components/DevelopRequest';
import { library } from '@fortawesome/fontawesome-svg-core';
library.add(fab, faWhatsapp, faHtml5, faJsSquare, faReact, faCss3, faNodeJs, faPhp, faJava, faAndroid, faAdobe, faPython, faUikit, faHackerrank)

class Catalogue extends Component {

  render() {
    return(
      <main id="App">
      <SideBar />
          <Nav />
          <div className="index">
          {/* <div className="bubble x1"></div>
          <div className="bubble x2"></div>
          <div className="bubble x3"></div>
          <div className="bubble x4"></div>
          <div className="bubble x5"></div>
          <div className="bubble x6"></div>
          <div className="bubble x7"></div>
          <div className="bubble x8"></div>
          <div className="bubble x9"></div>
          <div className="bubble x10"></div> */}
           <h1 className="codeflare">Code<span>flare</span></h1>
           <h3>Are You Prepared For The <span className="alt-col">Future?</span></h3>
           <p>Build Awesome Applications. Learn to code</p>
            <div className="button sign-in red">
              <Link to="/catalogue/develop" className="gal">
             Develop <FontAwesomeIcon className="chevR" icon = { faChevronRight }/><FontAwesomeIcon className="chevR2" icon = { faChevronRight }/>
             </Link>
           </div>
       </div>
       <div className="welcome">
         <div></div>
         <div>
           <h1>Skill up</h1>
           <p>Codeflare offers practical, in-depth and comprehensive coding classes that gets you ready for tasks
             and employments of the 21st century.</p>
             <p> Our ICT training courses are designed to quickly raise your skill level
             and provide you with the requisite knowledge needed to achieve your goals.
           </p>
           <p>You will learn how to build practical, real-life applications using relevant programming languages and technologies.</p>
           <a className="butt" rel="noopener noreferrer" href="https://www.google.com/maps/place/Codeflare+Limited+--+ICT+And+Software+Development+Training+And+Services/@9.1583578,7.3190551,17z/data=!3m1!4b1!4m5!3m4!1s0x104e0d789e764029:0x47c78ad66bd017e6!8m2!3d9.1583578!4d7.3212438"  target="_blank">See What People Are Saying</a>
         </div>
       </div>

       <div className="ict">
         <div>
          <h1>Why You Should be Proficient in ICT</h1>
          </div>
          <div>
            <p>With the demand for ICT growing, ICT professionals help to support the emerging goals and cultures of the people and organizations they serve.
              ICT professionals are able to combine the various technology skills to create impacts on the sectors that they serve.
            </p>
            <p>
              Our ICT programs and courses are designed for those who want to build a career as an ICT professional.
              You can increase your knowledge and skills through hands-on experiences and courses that build on one another.
              Our programs are designed to meet employer needs for IT and communication skills.
            </p>
          </div>
          <div>
          <ul class="list-group list-group-horizontal-sm">
            <li class="list-group-item">Computer Programmers</li>
            <li class="list-group-item">Web Designers</li>
            <li class="list-group-item">Web Development Specialists</li>
          </ul>
          <ul class="list-group list-group-horizontal-sm">
            <li class="list-group-item">Mobile App Developers</li>
            <li class="list-group-item">Data Scientists</li>
            <li class="list-group-item">Database Administrators</li>
          </ul>
          <ul class="list-group list-group-horizontal-sm">
            <li class="list-group-item">Database Analysts</li>
            <li class="list-group-item">Software Developers</li>
            <li class="list-group-item">Software Analysts</li>
            <li class="list-group-item">UI/UX Designers</li>
          </ul>
          <ul class="list-group list-group-horizontal-sm">
            <li class="list-group-item">Game Developers</li>
            <li class="list-group-item">Frontend Devs</li>
            <li class="list-group-item">Backend Devs</li>
          </ul>
          <ul class="list-group list-group-horizontal-sm">
            <li class="list-group-item">API Developers</li>
            <li class="list-group-item">Security Develper</li>
          </ul>
          </div>
       </div>

       <div className="trending">
       <h1>Popular Courses To Learn Now</h1>
       <p>Trending Technologies</p>
       </div>
       <section className="courses">
       <Link to="/catalogue/frontend">
         <div>
           <img src={js} className="icon" alt="ict training in abuja" />
           <p>Path</p>
           <p>Frontend Web Developer Bundle</p>
           <p>HTML5, CSS3, Bootstrap, JavaScript</p>
           <p>Take a look <span><FontAwesomeIcon icon = { faChevronRight }/></span></p>
           </div>
           </Link>

           <Link to="/catalogue/backend">
          <div>
            <img src={php} className="icon" alt="ict training in abuja" />
            <p>Path</p>
            <p>Backend Web Developer Bundle</p>
            <p>HTML5, CSS3, Bootstrap, PHP & MySQL</p>
            <p>Take a look <span><FontAwesomeIcon icon = { faChevronRight }/></span></p>
          </div>
         </Link>

         <Link to="/catalogue/data-science">
         <div>
           <img src={python} className="icon" alt="ict training in abuja" />
         <p>Path</p>
           <p>Data Science</p>
           <p>Python, Data Visualization and Analysis</p>
           <p>Take a look <span><FontAwesomeIcon icon = { faChevronRight }/></span></p>
         </div>
         </Link>

         <Link to="/catalogue/react-training">
         <div>
         <img src={react} className="icon" alt="ict training in abuja" />
         <p>Path</p>
           <p>Web Development With React Js</p>
           <p>CSS3, Bootstrap, ES6, REACT</p>
           <p>Take a look <span><FontAwesomeIcon icon = { faChevronRight }/></span></p>
         </div>
         </Link>

         <Link to="/catalogue/fullstack-js">
         <div>
           <img src={nodejs} className="icon" alt="ict training in abuja" />
         <p>Path</p>
           <p>Full-stack Js</p>
           <p>HTML5, CSS3, Bootstrap, ES6, NODE JS, MySQL</p>
           <p>Take a look <span><FontAwesomeIcon icon = { faChevronRight }/></span></p>
         </div>
          </Link>

          <Link to="/catalogue/fullstack-web-development">
         <div>
           <img src={php} className="icon" alt="ict training in abuja" />
         <p>Path</p>
           <p>Full-stack Web Development</p>
           <p>HTML5, CSS3, JavaScript, PHP, MySQL</p>
           <p>Take a look <span><FontAwesomeIcon icon = { faChevronRight }/></span></p>
           </div>
           </Link>

         <Link to="/catalogue/java-training">
         <div>
           <img src={java} className="icon" alt="ict training in abuja" />
         <p>Path</p>
           <p>Java Programming</p>
           <p>Learn Java concepts using NetBeans IDE</p>
           <p>Take a look <span><FontAwesomeIcon icon = { faChevronRight }/></span></p>
         </div>
         </Link>

         <Link to="/catalogue/android-development-training">
         <div>
           <img src={android} className="icon" alt="ict training in abuja" />
         <p>Path</p>
           <p>Android App Development</p>
           <p>Java, Android Development</p>
           <p>Take a look <span><FontAwesomeIcon icon = { faChevronRight }/></span></p>
         </div>
         </Link>

         <Link to="/catalogue/cross-platform-app-development-training">
         <div>
           <img src={react} className="icon" alt="ict training in abuja" />
         <p>Path</p>
           <p>IOS/Android App Development</p>
           <p>CSS3, ES6, React Native</p>
           <p>Take a look <span><FontAwesomeIcon icon = { faChevronRight }/></span></p>
         </div>
         </Link>

         <Link to="/catalogue/ui-ux-design">
         <div>
           <img src={adobexd} className="icon" alt="ict training in abuja" />
         <p>Path</p>
           <p>UI/UX Design</p>
           <p>Learn UI/UX with Adobe XD</p>
           <p>Take a look <span><FontAwesomeIcon icon = { faChevronRight }/></span></p>
         </div>
         </Link>

         <Link to="/catalogue/photoshop">
         <div>
           <img src={photoshop} className="icon" alt="ict training in abuja" />
         <p>Path</p>
           <p>Graphic Design</p>
           <p>Create Alluring Graphics with Photoshop</p>
           <p>Take a look <span><FontAwesomeIcon icon = { faChevronRight }/></span></p>
         </div>
         </Link>

         <Link to="/catalogue/ethical-hacking">
         <div>
           <img src={linux} className="icon" alt="ict training in abuja" />
         <p>Path</p>
           <p>Ethical Hacking</p>
           <p>Penetration Testing with Linux</p>
           <p>Take a look <span><FontAwesomeIcon icon = { faChevronRight }/></span></p>
         </div>
         </Link>

       </section>

       <div className="student">
           <h1>Practical, Real-Life,<br /> Project-based Training</h1>
           <p>
             There are so many possibilities to be actualized when you have the right <br />digital and ICT skills
             at your fingertips. At Codeflare, we are committed to <br /> giving you practical and hands-on ICT training
             that will help you stand <br /> out and compete in an ever-growing digital world.
           </p>

           <p><Link className="gal" to="/gallery">See Our Gallery</Link></p>
       </div>

       {/*
       <div className="app-ad">
           <h1>Mobile App Templates <br />For Mobile App Developers</h1>

             <a href="https://play.google.com/store/apps/details?id=com.codeflare" className="gal">Download</a>

       </div>
       */}

       <DevelopRequest />
       <Subscribe />
       <Footer />
       </main>
    )
  }
}

  export default Catalogue;
